import 'twin.macro';
import React from 'react';
import { ReactComponent as Icon } from './PDF.svg';
import { IconProps } from '@teetsh/app/src/components/Icons/icon';

export function PDFIcon(props: IconProps) {
  return <Icon className={props.className} />;
}
